import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import AllChallengesContent from '../../components/dashboard/ChallengesSection/AllChallenges/AllChallengesContent';
import styles from '../../components/dashboard/ChallengesSection/AllChallenges/allChallenges.module.css';
import { InboundContext } from '../../context/InboundContext';
import { getCreatorDetails } from '../../services/dashboard.service';
import useIsMobile from '../../hooks/useIsMobile';
import LoaderSvg from '../../assets/images/loader.svg';
import dashboardStyles from '../../styles/dashboard.module.css';

export default function Challenges() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const { homePageData, setHomePageData, inboundData } = useContext(InboundContext);
  const [isLoading, setIsLoading] = useState(!homePageData);

  useEffect(() => {
    if (!isMobile) navigate('/dashboard');
  }, [isMobile, navigate]);

  useEffect(() => {
    if (homePageData) {
      setIsLoading(false);
      return;
    }

    const fetchHomePageData = async () => {
      setIsLoading(true);
      const response = await getCreatorDetails({});
      if (response.status) setHomePageData(response.data);
      setIsLoading(false);
    };

    fetchHomePageData();
  }, [homePageData, setHomePageData]);

  if (!isMobile) return null;

  const creatorAddresses = homePageData?.creatorDetails?.addresses;
  const creatorAddress = creatorAddresses ? creatorAddresses[creatorAddresses.length - 1] : undefined;

  return (
    <DashboardWrapper heading="All challenges" onBack={() => navigate('/dashboard')}>
      {isLoading || !homePageData ? (
        <div className={dashboardStyles.loaderDiv}>
          <img src={LoaderSvg} alt="loader" width={100} />
        </div>
      ) : (
        <div className={styles.page}>
          <AllChallengesContent
            defaultCurrency={homePageData.defaultCurrency}
            address={creatorAddress}
            brandName={inboundData?.landingPage?.brandName || 'Brand'}
          />
        </div>
      )}
    </DashboardWrapper>
  );
}
